import React from 'react';
import PropTypes from 'prop-types';
import { withRouteData } from 'react-static';
import UserAgent from 'express-useragent';
import ReactHelmet from 'react-helmet';

import Helmet from '../components/helmet/Helmet';
import PageIntlProvider from '../components/provider/PageIntlProvider';
import Chrome from '../components/chrome/Chrome';
import AnchorScroll from '../components/main/utils/AnchorScroll';

const PRETENDARD_JP_CSS = '/fonts/pretendard-jp/pretendard-jp-dynamic-subset.css';

class Page extends React.Component {
  getChildContext = () => {
    const { isMobile, isiPhone, isiPad, isiPod, isAndroid, isWindows, isMac } =
      typeof document !== 'undefined' && UserAgent.parse(navigator.userAgent);
    return { isMobile, isiPhone, isiPad, isiPod, isAndroid, isWindows, isMac };
  };

  render = () => {
    const { children, language, locale, metaData, showSmartBanner, gtmContainerId, ...props } =
      this.props;

    return (
      <PageIntlProvider locale={locale} language={language}>
        <Chrome {...props}>
          <AnchorScroll />
          <ReactHelmet htmlAttributes={{ lang: language }}>
            {language === 'ja' && <link rel="stylesheet" href={PRETENDARD_JP_CSS} />}
          </ReactHelmet>
          {metaData && (
            <Helmet
              data={metaData}
              showSmartBanner={showSmartBanner}
              gtmContainerId={gtmContainerId}
            />
          )}
          {children}
        </Chrome>
      </PageIntlProvider>
    );
  };
}

Page.childContextTypes = {
  isMobile: PropTypes.bool,
  isiPhone: PropTypes.bool,
  isiPad: PropTypes.bool,
  isiPod: PropTypes.bool,
  isAndroid: PropTypes.bool,
  isWindows: PropTypes.bool,
  isMac: PropTypes.bool,
};

Page.propTypes = {
  path: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  children: PropTypes.node,
  gtmContainerId: PropTypes.string,
};

export default withRouteData(Page);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/containers/Page.js